import * as React from 'react';
import { Table } from 'react-bootstrap';
import { getPeerGroupData, IFilter, IPeerGroupTabsProps, round } from '../../lib/http';
import uuid from 'uuid';

interface IPeerGroupTable {
  currentIndex: any[]
  giv: any[]
  categories: string[]
  data: any[]
  filters: IFilter
}

export class PeerGroupYearOverYearTable extends React.Component<
  IPeerGroupTabsProps, IPeerGroupTable> {
  state: IPeerGroupTable = {
    categories: [],
    data: [],
    filters: { assetLevel: -1 },
    giv: [],
    currentIndex: [],
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  mapFilterIdToColumn(filterId) {
    if (filterId === 0) return '';
    if (filterId === 2) return 'fiveHundred';
    if (filterId === 3) return 'fifty';
    if (filterId === 4) return 'five';
    if (filterId === 5) return 'twenty';
    if (filterId === 6) return 'two';
    if (filterId === 7) return 'oneHundred';
    if (filterId === 8) return 'ten';
    if (filterId === 9) return 'one';
  }

  loadSeries(filters: IFilter) {
    const performanceRequestTab = {
      action: "getAnnualPeerGroupData",
      request: { assetLevel: this.props.filters.assetLevel },
    };
    const column = this.mapFilterIdToColumn(filters.assetLevel)
    getPeerGroupData(performanceRequestTab).then((response: any[]) => {

      const categories = response.map(dataPoint => dataPoint['date'])
      const givData = response.map(dataPoint => parseFloat(round(dataPoint['giv'], 1)))
      const giv = ['GIV Index', ...givData]
      let currentIndex = []
      if (filters.assetLevel !== 0) {
        const indexData = response.map(dataPoint => parseFloat(round(dataPoint[column], 1)))
        currentIndex = [filters.assetName + ' Index', ...indexData]
      }

      this.setState({ giv, currentIndex, categories });
    });
  }


  render() {
    const { categories, giv, currentIndex } = this.state
    return (
      <Table>
        <thead>
          <tr>
            <th></th>
            {categories && categories.map(category => <th key={category}>{category}</th>)}
          </tr>
        </thead>
        <tbody>
          <tr>
            {giv.map((value, index) => <td key={value + Math.random()}>{index === 0 ? <i className="fa fa-circle" style={{ color: '#8EA9DB' }} /> : null}&nbsp;{index === 0 ? value : Number(value).toFixed(1)}{index === 0 ? '' : '%'}</td>)}
          </tr>
          <tr>
            {currentIndex.map((value, index) => <td key={value + Math.random()}>{index === 0 ? <i className="fa fa-circle" style={{ color: '#B4C6E7' }} /> : null}&nbsp;{index === 0 ? value : Number(value).toFixed(1)}{index === 0 ? '' : '%'}</td>)}
          </tr>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/Performance/PeerGroupYearOverYearTable/index.tsx